import { createAction } from 'redux-actions';
import { SET_FOOTER_DATA } from './actionTypes';
import {
  getFooterNavigations,
  getFooterPlatform
} from '../../service/platform-config';
import STATUS_CODE from '../../request/statusCode';

const setFooterData = createAction(SET_FOOTER_DATA);

const getFooterData = () => {
  return dispatch => {
    return Promise.all([getFooterNavigations(), getFooterPlatform()]).then(
      ([navsRes, platformRes]) => {
        if (
          navsRes.statusCode === STATUS_CODE.OK &&
          platformRes.statusCode === STATUS_CODE.OK
        ) {
          const data = {
            navs: navsRes.data,
            platform: platformRes.data
          };
          dispatch(setFooterData(data));
          return data;
        }
        return undefined;
      }
    );
  };
};

export { getFooterData, setFooterData };
